import { ArticleService, Contract, Order } from '@/types'
import { router } from '@inertiajs/react'

// Mirrors OrderPolicy#destroy?: accueil can delete an order — or any of its articles/services —
// only while the order is still a draft; once launched (dispatched), only admins can.
export function canDeleteOrder(order: Order, { isAdmin, isAccueil }: { isAdmin: boolean; isAccueil: boolean }) {
  return isAdmin || (isAccueil && !order.dispatched_at)
}

export function buildCatalogFor(contracts: Contract[], fallback: ArticleService[]): (order: Order) => ArticleService[] {
  const catalogByContractId = new Map(
    contracts.map((contract) => [contract.id, contract.available_article_services ?? fallback])
  )
  return (order: Order) => (order.contract_id && catalogByContractId.get(order.contract_id)) || fallback
}

export function createDraftOrder({
  organizationSlug,
  customerId,
  contractId,
  onSuccess,
}: {
  organizationSlug: string
  customerId: number | null
  contractId: number | null
  onSuccess?: (orderId: number | null) => void
}) {
  router.post(
    `/organizations/${organizationSlug}/orders`,
    { order: { customer_id: customerId, contract_id: contractId } },
    {
      onSuccess: (page) => {
        const updatedOrders = page.props.orders as Order[]
        const newOrder = updatedOrders
          .filter(
            (order) =>
              order.customer_id === customerId &&
              order.contract_id === contractId &&
              order.articles.length === 0
          )
          .sort((a, b) => b.id - a.id)[0]
        onSuccess?.(newOrder?.id ?? null)
      },
    }
  )
}
